import { motion } from 'framer-motion';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  animated?: boolean;
}

const sizes = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-14',
  xl: 'h-20',
};

export function Logo({ size = 'md', animated = true }: LogoProps) {
  const Component = animated ? motion.img : 'img';
  const animationProps = animated
    ? {
        whileHover: { scale: 1.05 },
        transition: { type: 'spring' as const, stiffness: 300 },
      }
    : {};

  return (
    <Component
      {...animationProps}
      src="/images/btalentstar-logo.png"
      alt="BTalentStar"
      className={`${sizes[size]} w-auto cursor-pointer`}
      loading="eager"
    />
  );
}

export function LogoMark({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' | 'xl' }) {
  return (
    <img
      src="/images/btalentstar-logo.png"
      alt="BTalentStar"
      className={`${sizes[size]} w-auto`}
      loading="eager"
    />
  );
}

